// App Imports
import {
  HANDLE_RECEIPTS_SEARCH_REQUEST,
  HANDLE_RECEIPTS_SEARCH_RESPONSE,
  HANDLE_RECEIPTS_SEARCH_FAILURE,
} from "./actions";

// Initial State
export const arReceiptsInitialState = {
  error: null,
  isLoading: true,
  data: {
    receipts: {
      items: [],
      toDelete: [],
      toUpdate: [],
    },
    summary: {
      totalRows: 0
    }
  }
};

// State
export default (state = arReceiptsInitialState, action) => {
  switch (action.type) {

    case HANDLE_RECEIPTS_SEARCH_REQUEST:
      return {
        ...state,
        error: action.error,
        isLoading: action.isLoading,
      };
    case HANDLE_RECEIPTS_SEARCH_RESPONSE:
      var newStateData = state.data;
      if (action.resetCache) {
        let receipts = {
          items: action.searchResponse.items,
          toDelete: [],
          toUpdate: [],
        };
        newStateData.receipts = receipts;
      } else {
        let receipts = {
          items: newStateData.receipts.items.concat(
            action.searchResponse.items
          ),
          toDelete: [],
          toUpdate: [],
        };
        newStateData.receipts = receipts;
      }
      if (action.searchResponse.summary && action.searchResponse.summary.totalRows) {
        newStateData.summary = action.searchResponse.summary;
      }
      return {
        ...state,
        error: null,
        data: newStateData,
        isLoading: action.isLoading,
      };
    case HANDLE_RECEIPTS_SEARCH_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    default:
      return state;
  }
};
